module.exports = __webpack_public_path__ + "media/images/emblems/Moosseedorf-coat_of_arms-8e1040fb739a7c84aaf5a904305e9ea2.svg";